import { apiSlice } from "./apiSlice";

export const societyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createSociety: builder.mutation({
      query: (societyData) => ({
        url: "/societies/createSociety",
        method: "POST",
        body: societyData,
      }),
      invalidatesTags: ["Society"],
    }),

    deleteSociety: builder.mutation({
      query: (id) => ({
        url: `/societies/deleteSociety/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Society"],
    }),

    updateSociety: builder.mutation({
      query: ({ societyData, id }) => ({
        url: `/societies/updateSociety/${id}`,
        method: "PATCH",
        body: societyData,
      }),
      invalidatesTags: ["Society"],
    }),

    getAllSocieties: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/societies/getAllSocieties?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Society"],
    }),

    getSocietyLogs: builder.query({
      query: ({ page = 1, search, type } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);
        if (type) params.append("type", type);

        return {
          url: `/societies/getSocietyLogs?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Society"],
    }),

    getSocietyById: builder.query({
      query: (id) => ({
        url: `/societies/getSocietyById/${id}`,
        method: "GET",
      }),
    }),
    exportSocieties: builder.query({
      query: (status) => ({
        url: `/societies/exportSocieties?status=${status}`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
      transformResponse: (response) => response,
    }),

    addSocietyTimeline: builder.mutation({
      query: ({ timelineData, societyId }) => ({
        url: `/societies/addSocietyTimeline/${societyId}`,
        method: "POST",
        body: timelineData,
      }),
      invalidatesTags: ["SocietyTimeLine"],
    }),
    updateSocietyTimeline: builder.mutation({
      query: ({ timelineData, id }) => ({
        url: `/societies/updateSocietyTimeline/${id}`,
        method: "PATCH",
        body: timelineData,
      }),
      invalidatesTags: ["SocietyTimeLine"],
    }),
    getSocietyTimeline: builder.query({
      query: ({ societyId }) => {
        return {
          url: `/societies/getSocietyTimeline/${societyId}`,
          method: "GET",
        };
      },
      providesTags: ["SocietyTimeLine"],
    }),
    deleteSocietyTimeline: builder.mutation({
      query: (id) => ({
        url: `/societies/society-timeline/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SocietyTimeLine"],
    }),
  }),
});

export const {
  useCreateSocietyMutation,
  useUpdateSocietyMutation,
  useDeleteSocietyMutation,
  useGetAllSocietiesQuery,
  useGetSocietyByIdQuery,
  useLazyExportSocietiesQuery,
  useGetSocietyLogsQuery,
  useAddSocietyTimelineMutation,
  useGetSocietyTimelineQuery,
  useUpdateSocietyTimelineMutation,
  useDeleteSocietyTimelineMutation,
} = societyApi;
